<template>
	<div class="info-popup">
		<div class="info-main">
			<Button class="close-btn" :action="close" />
			<ul class="scrolling-content wysiwyg-content">
				<li
					class="section"
					v-for="section in sections"
					:key="section.id"
				>
					<h2 class="header">{{ section.heading }}</h2>
					<p class="description" v-html="section.text" />
				</li>
			</ul>
		</div>
		<div class="info-footer">
			<LinkHandler
				class="info-footer-link"
				v-for="link in links"
				:key="link.id"
				:url="link.url"
				:title="link.title"
			/>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Button from "@/components/base/Button";
import LinkHandler from "@/components/base/LinkHandler";

export default {
	name: 'SidebarInfoPopup',
	components: {
		Button,
		LinkHandler,
	},
	computed: {
		...mapState({
			sections: (state) => state.global.api.data.ui.info_screen.section,
			links: (state) => state.global.api.data.ui.info_screen.links,
		}),
	},
	methods: {
		...mapActions({
			deactivateModal: "global/modal/deactivate",
		}),
		close() {
			this.deactivateModal();
			this.$store.dispatch("sound/fx/play", { id: "generic_wipe" });
		},
	},
};
</script>

<style lang="scss" scoped>
	.info-popup {
		height: 85vh;
		width: 75vw;

		@include desktop {
			height: 80vh;
			width: 90vh;
		}

		@include desktop-sm {
			min-height: 500px;
			min-width: 800px;
		}
	}

	.info-main {
		position: relative;
		width: 80%;
		height: 85%;
		margin: 0 auto;
		align-items: center;
		display: flex;
		flex-direction: column;
		justify-content: center;
		overflow: hidden;
		background-image: url('~@/assets/images/info-main-background.svg');
		background-repeat: no-repeat;
		background-position: center;
		background-size: 100% 100%;
	}

	.scrolling-content {
		position: relative;
		display: flex;
		flex-direction: column;
		text-align: center;
		color: $off-white-dark;
		font-family: $body-font-alt;
		overflow: auto;
		margin-top: 10%;
		padding: 0 20%;
		width: 100%;
		z-index: 1;

		* {
			margin-left: auto;
			margin-right: auto;
		}

		&::-webkit-scrollbar {
			-webkit-appearance: none;
			width: 7px;
		}

		&::-webkit-scrollbar-thumb {
			border-radius: 4px;
			background-color: $primary-color;
		}
	}

	.section { margin-bottom: 2em; }

	.header {
		color: $primary-color;
		font-family: $body-font-script;
		text-transform: uppercase;
	}

	.info-footer {
		width: 100%;
		height: 15%;
		align-items: center;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: space-around;
		font-family: $body-font-alt;
		font-size: $font-size-x-sm;
		color: $alt-color;
		text-transform: uppercase;
		background: linear-gradient(0.25turn, #2D1F16, #231A14);
		border-radius: 30px;

		@include tablet { font-size: $font-size-base; }
		@include desktop { font-size: $font-size-base; }
	}

	.close-btn {
		position: absolute;
		top: 10%;
		right: 5%;
	}
</style>



// WEBPACK FOOTER //
// src/components/game/sidebar/SidebarInfoPopup.vue